import { api } from 'api/base';

export const getOrders = async (driverId: string) => {
    const params = { driverId };
    const response = await api.get('/orders', { params });
    return response.data;
};

export const getUnassignedOrders = async () => {
    const response = await api.get('/orders/unassigned');
    return response.data;
};

export const createOrder = async (order: { order_id: string, client_name: string }) => {
    const response = await api.post('/orders/create', order);
    return response.data;
};

